export default __webpack_public_path__ + "static/media/rank-curve.231245f0.svg";